import $ from 'jquery';
import run from '../../../utilities/run';
import EditChecker from '../../../components/EditChecker/EditChecker';
import { setElementsFromScope, setOptionsForSelect } from "../../../utilities/selectorHelpers";
const _ = require("underscore");

run("#edit-return-address-outer-div", ()=>{
  const el = $("#edit-return-address-outer-div");
  editRetailerReturnLocations(el);
});

function editRetailerReturnLocations(el){

	const facilityType = el.find("#cad-retailer-address-type");
	const vendorAuthRequiredSection = el.find(".if-vendor-returned");
  const inboundClassificationSection = el.find("#inbound-classfication-div");
	const returnAuthFlag = el.find("#return-auth-req");
	const standingRaNumber = el.find("#standing-ra-number");

	//const defaultEntityAddressTypes = el.data("default-entity-address-types");
	const retailerAddress = el.data("retailer-address");
	const retailerAddressAttributes = el.data("retailer-address-attributes");

	// setOptionsForSelect({
  //   selectElement: facilityType,
  //   list: defaultEntityAddressTypes,
  //   valueDataKey: "cdmValue",
  //   textDataKey: "cdmMeaning",
  //   initialSelectValue: ()=>{
  //     return retailerAddress.cadAddressType || "return";
  //   }
  // });


	facilityType.on("change", function(e) {
		showOrHideVendorAuth();
    showOrHideInboundClassification();
	});

	returnAuthFlag.on("change", function(e){
		if($(this).prop("checked") == false){
        	clearRaNumber();
        }
	});

	function showOrHideVendorAuth(){
		if(facilityType.val() == "vendor"){
			vendorAuthRequiredSection.show()
		}else{
			vendorAuthRequiredSection.hide();
		}
	}

  function showOrHideInboundClassification(){
		if(facilityType.val() == "return"){
			inboundClassificationSection.show()
		}else{
			inboundClassificationSection.hide();
		}
	}

	function clearRaNumber(){
		if(returnAuthFlag.prop("checked") == false){
			standingRaNumber.val("");
		}

    }

    function retailerAddressAttributesCheck(){
    	if(retailerAddressAttributes != null && retailerAddressAttributes.length > 0) {
    		$(retailerAddressAttributes).each(function(){
	        	if(this.caaKey == 'vendor_ra_required'){
	             	if(this.caaValue == "true"){
	               		returnAuthFlag.prop('checked', true);
	               	}else{
	               		returnAuthFlag.prop('checked', false);
	               	}
	            }

	            if(this.caaKey == 'vendor_standing_ra'){
	               standingRaNumber.val(this.caaValue);
	            }
	       	});
    	}
    }


    retailerAddressAttributesCheck();
    showOrHideVendorAuth();
    showOrHideInboundClassification();
}



// WEBPACK FOOTER //
// ./src/pages/retailer/maintainLocation/maintainReturnLocations.js